export default "__VITE_ASSET__BMfYcNd2__"